import { useEffect, useState, useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from '../../../components/Toast'
import { getCasinoGamesCategoryStart , deleteCasinoGamesCategoryStart} from '../../../store/redux-slices/superAdminCasinoManagement'

const INITIAL_LIMIT = 10

const useCategoryGamesListing = () => {
  const dispatch = useDispatch()
  const [showCasinoGamesModal, setShowCasinoGamesModal] = useState(false)
  const [selectedCategory, setSelectedCategory] = useState({ isOpen: false })

  const [limit, setLimit] = useState(INITIAL_LIMIT)
  const [page, setPage] = useState(1)
  const [gameCategoryId, setCasinoGameId] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [games, setGames] = useState([])


  const { CategoryGamesData, loadingCategorygames, deleteCasinoGamesCategorySuccess } = useSelector((state) => state.superAdminCasino)

  const pagination = useMemo(() => CategoryGamesData?.pagination || {}, [CategoryGamesData])

  useEffect(() => {
    if (!showCasinoGamesModal || !gameCategoryId) return

    dispatch(
      getCasinoGamesCategoryStart({
        data: {
          limit,
          pageNo: page,
          gameCategoryId,
        },
      })
    )
  }, [dispatch, limit, page, gameCategoryId, showCasinoGamesModal])

  useEffect(() => {
    if (!CategoryGamesData?.games) return

    setGames((prevGames) => {
      const newGames = page === 1 ? CategoryGamesData.games : [...prevGames, ...CategoryGamesData.games]
      const uniqueGames = new Map()

      newGames.forEach((game) => {
        if (!uniqueGames.has(game.casinoGameId)) {
          uniqueGames.set(game.casinoGameId, game)
        }
      })

      return Array.from(uniqueGames.values())
    })
  }, [CategoryGamesData, page])

  useEffect(() => {
    if (!pagination?.totalPages) return

    const totalPages = Number(pagination.totalPages) || 0
    setHasMore(page < totalPages)
  }, [page, pagination])

  const resetGames = useCallback(() => {
    setPage(1)
    setGames([]);

    if (page === 1 && gameCategoryId) {
      // If we are already on page 1, the page state change won't trigger the fetch useEffect.
      // So, we dispatch the fetch action directly.
      dispatch(
        getCasinoGamesCategoryStart({
          data: {
            limit,
            pageNo: 1,
            gameCategoryId,
          },
        })
      );
    }
  }, [page, gameCategoryId, limit, dispatch]);

  const handleShowGamesModal = useCallback((category) => {
    setCasinoGameId(category?.gameCategoryId)
    setSelectedCategory({ ...category, isOpen: true })
    setShowCasinoGamesModal(true)
    setPage(1)
    setGames([])
  }, [])

  const handleCloseGamesModal = useCallback(() => {
    setShowCasinoGamesModal(false)
    setCasinoGameId(null)
    setSelectedCategory({ isOpen: false })
    setPage(1)
    setGames([])
  }, [])

  const fetchNextPage = useCallback(() => {
    if (loadingCategorygames || !hasMore) return
    setPage((prevPage) => prevPage + 1)
  }, [loadingCategorygames, hasMore])

  const onHandleDeleteCategoryGame = (props) => {
    dispatch(deleteCasinoGamesCategoryStart({
      data: {
        gameCategoryId: selectedCategory.gameCategoryId,
        casinoGameId: props.casinoGameId,
      }, 
      onSuccess({successMsg}) {
        toast(successMsg , "success")
        resetGames()
      }
    }));
  }


  return {
    showCasinoGamesModal,
    setShowCasinoGamesModal: handleShowGamesModal,
    categoryGamesLimit: limit,
    setcategoryGameLimit: setLimit,
    categoryPage: page,
    setCategoryPage: setPage,
    gameCategoryId,
    setCasinoGameId,
    categoryModalSelectedcategory: selectedCategory,
    setCategoryModalSelectedcategory: setSelectedCategory,
    loadingCategorygames,
    categoryGamesData: games,
    hasMore,
    fetchNextPage,
    handleCloseGamesModal,
    onHandleDeleteCategoryGame,
    resetGames
  }
}

export default useCategoryGamesListing